export const lsbWorks = {
  movie: [
    {
      id: 1,
      title: '매피스토',
      year: '2020',
      image: require('./movie/A. 매피스토(영화).jpeg')
    },
    {
      id: 2,
      title: '은밀하게 위대하게',
      year: '2013',
      image: require('./movie/B. 은밀하게 위대하게(영화).jpeg')
    },
  ],
  drama: [
    {
      id: 1,
      title: '우아한 제국',
      year: '2023',
      image: require('./drama/1. 우아한 제국(드라마).jpg')
    },
    {
      id: 2,
      title: '미스 몬테크리스토',
      year: '2021',
      image: require('./drama/2. 미스 몬테크리스토(드라마).jpg')
    },
    {
      id: 3,
      title: '사생활',
      year: '2020',
      image: require('./drama/3. 사생활(드라마).webp')
    },
    {
      id: 4,
      title: '루갈',
      year: '2020',
      image: require('./drama/4. 루갈(드라마).jpg')
    },
  ],
};
